import { Chip, Box } from "@mui/joy";
import { Link, useParams } from "react-router-dom";
import { capitalizeFirstLetter } from '@/utils/strings';

export function CategoriesList({ categories, size = "sm", variant = "soft", color = "neutral", gap = 0.5, clickable = true }) {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap, flexWrap: 'wrap' }}>
      {categories.map(category => (
        <CategoryChip key={category} category={category} size={size} variant={variant} color={color} clickable={clickable} />
      ))}
    </Box>
  );
}

function CategoryChip({ category, size, variant, color, clickable }) {
  const { householdId } = useParams();

  const chip = (
    <Chip size={size} variant={variant} color={color} sx={{ '&:hover': { backgroundColor: clickable ? 'neutral.300' : 'default' } }}>
      {capitalizeFirstLetter(category)}
    </Chip>
  );

  if (householdId && clickable) {
    return (
      <Link to={`/h/${householdId}/recipes?categories=${encodeURIComponent(category)}`} style={{ textDecoration: 'none' }}>{chip}</Link>
    );
  }
  return chip;
}

